export default {
    appeal: {
        error:             'Не удалось отправить апелляцию, попробуйте ещё раз',
        reasonPlaceholder: 'Укажите причину',
        title:             'Заявка на апелляцию',
    },
    chart: {
        downloadExcel: 'Скачать Excel',
        title:         {
            last30Days: 'Все лиды за последние 30 дней',
            last7Days:  'Все лиды за последние 7 дней',
            lastMonth:  'Все лиды за прошлый месяц',
            lastWeek:   'Все лиды за последнюю неделю',
            range:      'Все лиды за {range}',
            thisMonth:  'Все лиды за этот месяц',
            thisWeek:   'Все лиды за эту неделю',
        },
        total: 'Всего лидов',
    },
    export: {
        downloaded: 'Отчёт загружен',
        fileName:   'Отчет {name} {from}-{to}',
        heading:    {
            comment: 'Комментарий',
            date:    'Дата, время',
            name:    'Имя',
            payment: 'Оплата',
            phone:   'Номер телефона',
            status:  'Статус',
            type:    'Тип заявки',
        },
        loadError:   'Не удалось загрузить данные, попробуйте позднее',
        noRequests:  'Подходящих заявок нет.\nПопробуйте изменить параметры фильтра',
        payment:     'Оплата',
        requestType: {
            call:       'Звонок',
            form:       'Заявка с формы обратной связи',
            missedCall: 'Непринятый звонок',
        },
        sheetName: 'Список',
        statuses:  'Статусы',
        title:     'Скачать отчёт',
        type:      'Тип',
    },
    filters: {
        allAgents:  'Все',
        clearPhone: 'Очистить номер',
        payment:    {
            any:     'Любая оплата',
            notPaid: 'Неоплаченные',
            paid:    'Оплаченные',
        },
        phone:  'Номер телефона',
        status: {
            all:         'Все статусы',
            appeal:      'На апелляции',
            duplicate:   'Повторы',
            target:      'Целевые',
            unearmarked: 'Нецелевые',
        },
        type: {
            all: 'Все типы',
        },
    },
    list: {
        call:             'Звонок',
        commentError:     'Не удалось сохранить комментарий',
        declineError:     'Не удалось снять с апелляции',
        details:          'Детали',
        emptyText:        'Когда клиенты начнут звонить и оставлять заявки, вы увидите их здесь',
        emptyTitle:       'Лидов пока нет',
        form:             'Заявка',
        lead:             'Лид',
        missedCall:       'Пропущенный звонок',
        removeAppeal:     'Снять с апелляции',
        statusAndPayment: 'Статус и оплата',
        submitAppeal:     'Подать апелляцию',
    },
    payments: {
        notPaid: 'Неоплачен',
        paid:    'Оплачен',
    },
    statuses: {
        appeal:      'На апелляции',
        duplicate:   'Повтор',
        target:      'Целевой',
        unearmarked: 'Нецелевой',
    },
};
